module.exports = __webpack_public_path__ + "img/360.b7f74db0.png";